<script>
    import { onDestroy } from 'svelte';
    import BotonStats from "./BotonStats.svelte";
    import moment from 'moment';
    import { moneda } from '../../scripts';
    import ApexCharts from 'apexcharts'

    export let data=[];
    let dataChart=[];
    let chartObject=null;
    let counter=data.length;
    export let view='ALL'; // CHART | TABLE | ALL (Default)

    let total=0;

    $: if(data || view) {
        total=0;
        dataChart=[];
        data.forEach(element => { dataChart=[...dataChart, {x: moment(element.fecha).format("DD-MM-YYYY") ,y: element.total} ]; total+=element.total*1; });
        counter=dataChart.length;
        setTimeout(() => { updateChart(); }, 100);
    }
    onDestroy(() => {
        if(chart!==null) { chart.destroy();  chart=null;}
    });

    let chart=null;

    function updateChart()
    {
        if(chart!==null) { chart.destroy();  chart=null;}
        if(view=='TABLE') { return; }
        if(counter>0)
        {
            let options = {
                    chart: {
                        type: 'bar',
                        zoom: { enabled: false },
                        toolbar: { show: true },
                        height:'100%',                    
                    },
                    colors: ['#ffc107', '#545454'],
                    series: [{
                        name: 'Ventas',
                        data: dataChart,
                    }],
                    xaxis: {
                        categories: []
                    },
                    dataLabels: {
                        enabled: false
                    },
                    legend: {
                        show: false
                    },
                    yaxis: {
                            labels: {
                                formatter: function(val) {
                                    return moneda(val,'Q.');
                                }
                            }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                        }
                    },
                    markers: {
                        size: 1
                    },        
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        },
                    },
                    xaxis: {
                        labels: { 
                            rotate: -90, 
                            rotateAlways: true, 
                            offsetY: 5,
                            style: {
                                colors: '#000',
                                fontSize: '11px',
                                fontWeight: 400,
                            }
                        },
                    },                            
            }

            chart = new ApexCharts(chartObject, options);
            chart.render();
        }
    }

</script>

<div class='text-end'>
    <BotonStats bind:view={view} name='VentasDiaRadio' />
</div>

<h4 class='text-primary'><i class="bi bi-bar-chart-line me-1" />Ventas por dia</h4>


{#if counter==0}
    <div class="alert alert-secondary mt-3" role="alert">
        <i class="bi bi-server me-2"></i>No se encontraron registros
    </div>
{:else}

    <div style='height:400px;' class:d-none={view=='TABLE'}>
        <div id="chart" bind:this={chartObject}></div> 
    </div>

    <table class='table table-striped table-bordered table-sm mt-4' class:d-none={view=='CHART'}>
        <thead>
            <tr>
                <th>Fecha</th>                        
                <th class='text-end'>Facturas</th>
                <th class='text-end'>Ventas</th>
            </tr>
        </thead>
        <tbody>
        {#each data as item}
            <tr>
                <td class='fw-bold'>{moment(item.fecha).format('DD/MM/YYYY')}</td>
                <td class='text-end'>{item.facturas}</td>
                <td class='text-end'>{moneda(item.total,'Q.')}</td>
            </tr>
        {/each}
        </tbody>
        <tfoot>
            <tr>
                <th>&nbsp;</th>
                <th class='text-end'>Total</th>
                <th class='text-end'>{moneda(total,'Q.')}</th>
            </tr>
        </tfoot>        
    </table>
{/if}

